import { render, staticRenderFns } from "./LoginMenuButtonNew.vue?vue&type=template&id=a5d6fb20&scoped=true"
import script from "./LoginMenuButtonNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMenuButtonNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginMenuButtonNew.vue?vue&type=style&index=0&id=a5d6fb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d6fb20",
  null
  
)

export default component.exports